import React, { useEffect, useState } from 'react';
import axios from '../axios';
import { useParams } from 'react-router-dom';
import {
    Container,
    DetailsBtns,
    DetailsHeading,
    H1,
    H3,
    HeadingLeft, MediumSpacing,
    ProfileTable,
    Table,
    Td,
    Th,
    Tr
} from "../../styles";

const ProfileDetail = () => {
    const { username } = useParams();
    const [userInfo, setUserInfo] = useState(null);
    const [loading, setLoading] = useState(true);

    const fetchUserInfo = async (token) => {
        try {
            const response = await axios.get(`/profile/${username}/`, {
                headers: {
                    Authorization: `Bearer ${token}`
                }
            });
            setUserInfo(response.data);
            setLoading(false);
        } catch (error) {
            if (error.response && error.response.status === 401) {
                const newToken = await refreshToken();
                if (newToken) {
                    await fetchUserInfo(newToken);
                } else {
                    setLoading(false);
                }
            } else {
                console.error('Error fetching user info:', error);
                setLoading(false);
            }
        }
    };

    const refreshToken = async () => {
        const refresh = localStorage.getItem('refresh_token');
        if (!refresh) {
            window.location.href = '/login';
            return null;
        }
        try {
            const { data } = await axios.post('/token/refresh/', { refresh });
            localStorage.setItem('access_token', data.access);
            axios.defaults.headers.common['Authorization'] = `Bearer ${data.access}`;
            return data.access;
        } catch (error) {
            console.error('Error refreshing token:', error);
            localStorage.removeItem('access_token');
            localStorage.removeItem('refresh_token');
            window.location.href = '/login';
            return null;
        }
    };

    useEffect(() => {
        const token = localStorage.getItem('access_token');
        if (token) {
            fetchUserInfo(token);
        } else {
            setLoading(false);
        }
    }, [username]);

    if (loading) {
        return <div>Loading...</div>;
    }

    if (!userInfo) {
        return <div>User not found</div>;
    }

    const enrolledClasses = userInfo.enrolled_classes || [];
    const teachingCourses = userInfo.teaching_courses || [];

    return (
        <Container>
            <HeadingLeft>
            <H1>Profile Detail</H1>

            </HeadingLeft>
            <MediumSpacing/>
            <ProfileTable>
                <tbody>
                    <Tr>
                        <Td className="row_heading">ID</Td>
                        <Td className="row_heading">{userInfo.student_id || userInfo.lecturer_id || 'N/A'}</Td>
                    </Tr>
                    <Tr>
                        <Td className="row_heading">Email</Td>
                        <Td className="row_heading">{userInfo.email}</Td>
                    </Tr>
                    <Tr>
                        <Td className="row_heading">DOB</Td>
                        <Td className="row_heading">{userInfo.dob || 'N/A'}</Td>
                    </Tr>
                </tbody>
            </ProfileTable>
            {enrolledClasses.length > 0 && (
                <>
                                <MediumSpacing/>
                    <MediumSpacing/>
                    <HeadingLeft> <H3>Your Enrolled Classes:</H3></HeadingLeft>
                   <MediumSpacing/>
                    <Table>
                        <thead>
                            <Tr>
                                <Th>Course</Th>
                                <Th>Class Number</Th>
                                <Th>Semester</Th>
                                <Th>Grade</Th>
                            </Tr>
                        </thead>
                        <tbody>
                            {enrolledClasses.map((classInstance, index) => (
                                <Tr key={index}>
                                    <Td>{classInstance.course__name}</Td>
                                    <Td>{classInstance.number}</Td>
                                    <Td>
                                        Semester {classInstance.semester__semester} - {classInstance.semester__year}
                                    </Td>
                                    <Td>{userInfo.grades[classInstance.pk] || '-'}</Td>
                                </Tr>
                            ))}
                        </tbody>
                    </Table>
                </>
            )}
            {teachingCourses.length > 0 && (
                <> <MediumSpacing/>

                    <HeadingLeft>
                         <H3>Courses Taught:</H3>
                    </HeadingLeft>
                     <MediumSpacing/>
                    <Table>
                        <thead>
                            <Tr>
                                <Th>Course</Th>
                                <Th>Class Number</Th>
                                <Th>Semester</Th>
                                <Th>Year</Th>
                                <DetailsHeading>Details</DetailsHeading>
                            </Tr>
                        </thead>
                        <tbody>
                            {teachingCourses.map((course, index) => (
                                <Tr key={index}>
                                    <Td>{course.course__name}</Td>
                                    <Td>{course.number}</Td>
                                    <Td>Semester {course.semester__semester}</Td>
                                    <Td>{course.semester__year}</Td>
                                    <DetailsBtns>
                                        <a href={`/class/${course.pk}`}>View</a>
                                    </DetailsBtns>
                                </Tr>
                            ))}
                        </tbody>
                    </Table>
                </>
            )}
            {enrolledClasses.length === 0 && teachingCourses.length === 0 && (
                <p>There is no class to display</p>
            )}
        </Container>
    );
};

export default ProfileDetail;
